import { i18nTranslate } from 'src/utils'

export const loyaltyRewardsFormData = {
  dataTestId: 'loyalty-rewards',
  onTitle: i18nTranslate(
    'account.loyaltyOnTitle',
    'You are currently opted in to the Nu Skin Rewards program!'
  ),
  optOutTxt: i18nTranslate(
    'account.loyaltyoptOutTxt',
    'You are opted out of the Nu Skin Rewards Program!'
  ),
  optInTxt: i18nTranslate('account.loyaltyoptOffTxt', 'Opted In'),
  brandAffiliateUserTxt: i18nTranslate(
    'account.loyaltybrandAffiliateUserTxt',
    'Nu Skin Rewards Program is exclusively for Retail Customers and Members!'
  ),
}

// Taken copy for future reference for Loyalty Points
// optOutTxt: i18nTranslate(
//   'account.loyaltyoptOutTxt',
//   'You are currently opted out. Toggle on to opt in to the Nu Skin Rewards program!'
// ),
// optInTxt: i18nTranslate(
//   'account.loyaltyoptOffTxt',
//   'Toggle off to opt out from the Nu Skin Rewards!'
// ),
